import { useState } from "react";
import VehicleConfigService from "../services/VehicleConfigService";

interface VinData {
    vin: string;
    errorMessage: string;
    make: string;
    model: string;
    year: string;
    restraintsDriver: string;
    cab: string;
    transmission: string;
    vehicleType: string;
    engineDisplacement: string;
    brakesWeightRatingGVWR: string;
    series: string;
    assemblyCountry: string;
    axleWheelbase: string;
    engineManufacturer: string;
    assemblyPlant: string;
    bodyStyle: string;
    fuel: string;
    brakesPower: string;
    driveTrain: string;
    cylinders: string;
}

export const useVinDecoder = () => {
    const [nhtsaVins, setNhtsaVins] = useState("");
    const [nhtsaData, setNhtsaData] = useState<VinData[]>([]);
    const [nhtsaShowTable, setNhtsaShowTable] = useState(false);

    const handleTextareaChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setNhtsaVins(event.target.value);
    };

    const resetForm = () => {
        setNhtsaVins('');
        setNhtsaShowTable(false);
    };

    const decodeVinWithNhtsa = async () => {
        const vin = nhtsaVins.split("\n");
        try {
            const response = await VehicleConfigService.decodeTestVinWithNhtsa({ vin });
            const extractedData = response.data.nthsaDecodeResponseList.flatMap((item: any) =>
                item.Results.map((result: any) => ({
                    vin: result.VIN,
                    errorMessage: result.ErrorText,
                    errorCode: result.ErrorCode,
                    make: result.Make,
                    model: result.Model,
                    year: result.ModelYear,
                    restraintsDriver: result.AirBagLocFront,
                    cab: result.BodyCabType,
                    transmission: result.TransmissionStyle,
                    vehicleType: result.VehicleType,
                    engineDisplacement: result.DisplacementL,
                    brakesWeightRatingGVWR: result.GVWR,
                    series: result.Series,
                    assemblyCountry: result.PlantCountry,
                    axleWheelbase: result.WheelBaseLong,
                    engineManufacturer: result.EngineManufacturer,
                    assemblyPlant: result.PlantCompanyName,
                    bodyStyle: result.BodyClass,
                    fuel: result.FuelTypePrimary,
                    brakesPower: result.BrakeSystemType,
                    driveTrain: result.DriveType,
                    cylinders: result.EngineCylinders,
                }))
            );
            setNhtsaData(extractedData);
            setNhtsaShowTable(true);
        } catch (e) {
            console.error(e);
        }
    };

    const downloadCSV = () => {
        const csvRows = [
            ["VIN", "Status", "Make", "Model", "Year"],
            ...nhtsaData.map(row => [row.vin, row.errorMessage, row.make, row.model, row.year])
        ];

        const csvContent = csvRows.map(e => e.join(",")).join("\n");
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "vin_decode_results.csv");
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return {
        nhtsaVins,
        nhtsaData,
        nhtsaShowTable,
        setNhtsaShowTable,
        handleTextareaChange,
        resetForm,
        decodeVinWithNhtsa,
        downloadCSV,
    };
};